import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userId: null,
    email: null,
    name: null,
    isAuthenticated: false,
    loading: false,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.userId = action.payload.userId;
            state.email = action.payload.email;
            state.name = action.payload.name;
            state.isAuthenticated = true;
            state.loading = false;
        },
        clearUser: (state) => {
            state.userId = null;
            state.email = null;
            state.name = null;
            state.isAuthenticated = false;
            state.loading = false;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const { setUser, clearUser, setLoading } = userSlice.actions;
export default userSlice.reducer;